import { BASE_URL } from "./base_url";
import { commonRequest } from "./commonHTTPrequest";

// register api
export const registerNew = async (body) => {
    return await commonRequest("POST",`${BASE_URL}/register`,body)
}

//contact api
export const contactMessage = async (body) => {
    return await commonRequest("POST",`${BASE_URL}/contact`,body)
}